import { render, staticRenderFns } from "./dashboard-bulletin.vue?vue&type=template&id=0519bbe6&scoped=true"
import script from "./dashboard-bulletin.vue?vue&type=script&lang=ts"
export * from "./dashboard-bulletin.vue?vue&type=script&lang=ts"
import style0 from "./dashboard-bulletin.vue?vue&type=style&index=0&id=0519bbe6&prod&lang=less&scoped=true"
import style1 from "./dashboard-bulletin.vue?vue&type=style&index=1&id=0519bbe6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0519bbe6",
  null
  
)

export default component.exports